import React from 'react';
import { CHEATSHEET } from '../lib/keyboard.js';
import styles from './Dialog.module.css';
import cheatStyles from './KeyboardCheatsheet.module.css';

export default function KeyboardCheatsheet({ onClose }) {
  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div className={styles.panel} onClick={(e) => e.stopPropagation()} style={{ width: 520 }}>
        <div className={styles.title}>Keyboard shortcuts</div>
        <div className={styles.body}>
          <table className={cheatStyles.tbl}>
            <tbody>
              {CHEATSHEET.map(([k, desc]) => (
                <tr key={k}>
                  <td className={cheatStyles.key}><kbd>{k}</kbd></td>
                  <td className={cheatStyles.desc}>{desc}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className={styles.actions}>
          <button className={styles.btnPrimary} onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
